// extracted by mini-css-extract-plugin
module.exports = {"flavorText":"splashPage_flavorText__SKjLI"};